import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { ButtonLink } from './ButtonLink';
import { Eyebrow } from './Eyebrow';
import { fleetPoints } from '../data/content';
import { contact, images, urls } from '../data/site';
export function FleetSection() {
  return <section id="fleet" aria-labelledby="fleet-heading" className="bg-ink py-14 text-paper md:py-28" data-id="element-76" data-mp="3224sq0yi8o83">
      <div className="mx-auto grid max-w-[1320px] gap-12 px-5 sm:px-8 lg:grid-cols-2 lg:items-center lg:gap-20 lg:px-12" data-id="element-77" data-mp="2oaq7rol1ecye">
        <figure className="order-2 lg:order-1" data-id="element-78" data-mp="2t1q68y9t1330">
          <div className="relative aspect-[4/3] overflow-hidden bg-ink-soft lg:aspect-[5/6]" data-id="element-79" data-mp="2t3jeuj3z9xdn">
            <img src={images.workTruck} alt="Red-striped commercial work truck, broadside, carrying large equipment on its bed" loading="lazy" className="absolute inset-0 h-full w-full object-cover object-[50%_55%]" data-id="element-80" data-mp="2eedfmv55475r" />
          </div>
          <figcaption className="mt-3 flex items-center gap-3 text-sm text-steel-light" data-id="element-81" data-mp="2ad1pmoictjx1">
            <span aria-hidden="true" className="h-[2px] w-5 bg-brand" data-id="element-82" data-mp="z98k784663yb" />
            Commercial work truck with equipment on the bed
          </figcaption>
        </figure>

        <div className="order-1 lg:order-2" data-id="element-83" data-mp="1986g4w3xczrc">
          <Eyebrow tone="dark" data-id="element-84" data-mp="196vdx0q4o02c">For fleet managers</Eyebrow>
          <h2 id="fleet-heading" className="mt-5 font-display text-[40px] font-bold uppercase leading-[0.95] md:text-[56px] lg:text-[60px]" data-id="element-85" data-mp="14bg2effleg93">
            Your schedule matters. So does every truck.
          </h2>
          <p className="mt-6 max-w-[34rem] text-[17px] leading-relaxed text-steel-light md:text-lg" data-id="element-86" data-mp="bjmowvqx48vl">
            Tell us which unit is down, what happened and when you need it. We can discuss the bodywork, paint and
            scheduling details around your operation.
          </p>
          <ul className="mt-9 border-t border-ink-line" data-id="element-87" data-mp="3txdq5o3wgz0i">
            {fleetPoints.map(point => <li key={point} className="flex items-center gap-4 border-b border-ink-line py-4 text-[17px] font-medium" data-id="element-88" data-mp="3oy9gyxgz71a6">
                <span aria-hidden="true" className="h-2 w-2 shrink-0 bg-brand" data-id="element-89" data-mp="1xwbw5dk9ve58" />
                {point}
              </li>)}
          </ul>
          <div className="mt-9 flex flex-col gap-4 sm:flex-row sm:items-center sm:gap-6" data-id="element-90" data-mp="22nk9ulsmxlo7">
            <ButtonLink href={urls.quote} trailingIcon={ArrowRightIcon} className="w-full sm:w-auto" data-id="element-91" data-mp="26nca8b7vklih">
              Discuss a Fleet Repair
            </ButtonLink>
            <a href={contact.phoneHref} className="inline-flex min-h-[44px] items-center justify-center text-[15px] text-steel-light transition-colors duration-150 ease-out hover:text-paper sm:justify-start" data-id="element-92" data-mp="1ex6hsva1vmtm">
              or call&nbsp;<span className="font-semibold text-paper" data-id="element-93" data-mp="1nw1jpv62aar4">{contact.phoneDisplay}</span>
            </a>
          </div>
        </div>
      </div>
    </section>;
}